/* eslint-disable no-unused-vars */
import { _, helpers, React, ts, ui } from '_core';

import { useMemo } from 'react';

import { prepareCovariancesChart } from './helpers';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  fullScreen: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  definition: ts.types.signal.OptimizedModel;
  optimizedCovariance: string;
  title: string;
};

const Chart = ({ id, readOnly, fullScreen, loadWidgetData, definition, optimizedCovariance, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: optimizedCovariance,
        },
      });

      if (response) {
        setData(response.data);
      }
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (optimizedCovariance) loadData();
    return () => setData(null);
  }, [optimizedCovariance]);

  const formattedData = useMemo(() => {
    if (_.isNil(data)) return [];
    return prepareCovariancesChart(data, definition.signals);
  }, [data]);

  return (
    <ui.HeatmapChart
      id={id}
      data={formattedData}
      xAxisField="factor_x"
      yAxisField="factor_y"
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      exportTitle={title}
      fullScreen={fullScreen}
      readOnly={readOnly}
      rotation={45}
    />
  );
};

export default Chart;
